import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

// widgets
export { C360EditCampaignDialog } from './widgets/wrappers/edit-campaign';
export { C360AdBlockerWarning } from './widgets/AdBlockerWarning';

// features
export { C360UserMenu } from './features/UserMenu';
export { C360AdvertisersSearch } from './features/AdvertiserSearch';
export { C360ProposalStatus, makeProposalStatusConfig } from './features/ProposalStatus';
export { C360NotificationsDropdown } from './features/NotificationsDropdown';
export { C360AsideMenu } from './features/AsideMenu';

// components
export { C360Icon } from './components/Icon';
export { C360ProductLink } from './components/ProductLink';
export { C360SwitchButton } from './components/SwitchButton';
export { C360PortalButton } from './components/PortalButton';
export { C360Header, redirectToSSWebApp } from './components/Header';
export { C360Avatar } from './components/Avatar';
export { C360ProposalStep } from './components/ProposalStep';
export { C360SelectableItem } from './components/SelectableItem';
export { C360Footer } from './components/Footer';
export { C360AsideMenuExpander } from './components/AsideMenuExpander';
export { C360Provider } from './components/Provider';

// shared
export { getCssVar } from './shared/utils';
export { c360ThemeColors } from './plugins/theme';
export { useLink } from './shared/link';
export { getTheme } from './shared/theme';
export { Product } from './shared/utils/product';
export { default as defineAbilityFor } from './shared/define-ability-for';

// styles and typography
import { installC360Fonts } from './fonts';
import './styles/coolicons/coolicons.css';
import './styles/c360.css';

installC360Fonts();

export { default } from './plugin';
